import React from "react"
import styled, { css } from "styled-components"
import Link from "next/link"
import { ChevronLeft } from "./ChevronLeft"
import { useRouter } from "next/router"

const StyledIcon = styled(ChevronLeft)``

const StyledTitle = styled.p`
  margin: 0;
  padding: 0;
  font-size: 16px;
  color: #2f426c;
  font-weight: 600;
  ${(props) =>
    props.$color &&
    css`
      color: ${props.$color};
    `}
`

const StyledContainer = styled.button`
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  box-shadow: none;
  cursor: pointer;
  font: inherit;
  color: inherit;

  display: flex;
  align-items: center;
  margin-bottom: 16px;
`
export const BackButton = ({
  className,
  color = "#2f426c",
}: {
  className?: string
  color?: string
}) => {
  const router = useRouter()

  const handleBack = () => {
    router.back()
  }

  return (
    <StyledContainer onClick={handleBack} className={className}>
      <StyledIcon color={color} />
      <StyledTitle $color={color}>Back</StyledTitle>
    </StyledContainer>
  )
}
